// ADA Compliance: WCAG 2.2 A F7 - Auto-stop animated logo after 4.5 seconds
class AnimatedLogo extends HTMLElement {
  constructor() {
    super();
    this.timeoutId = null;
    this.img = null;
  }

  connectedCallback() {
    this.img = this.querySelector('img');
    
    if (!this.img) return;
    
    this.processLogo();
  }

  disconnectedCallback() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
  }

  isElementVisible(el) {
    if (!el) return false;
    const style = window.getComputedStyle(el);
    const rect = el.getBoundingClientRect();

    return (
      style.display !== 'none' &&
      style.visibility !== 'hidden' &&
      style.opacity !== '0' &&
      rect.width > 0 &&
      rect.height > 0
    );
  }

  setLogoImage(src, alt) {
    if (!src || !this.img) return;
    this.img.src = src;
    if (alt) this.img.alt = alt;
  }

  processLogo() {
    if (!this.img || this.img.getAttribute('data-ada-processed') === 'true') return;
    
    this.img.setAttribute('data-ada-processed', 'true');

    const parent = this.closest('.header-mb-middle, .header-logo, .utilHead, .header-panel-bt-l-main');
    const staticSrc = this.img.src || this.img.getAttribute('src') || '';
    const staticAlt = this.getAttribute('data-static-alt') || this.img.alt || '';

    if (!parent || !this.isElementVisible(parent) || !this.isElementVisible(this.img)) {
      this.setLogoImage(staticSrc, staticAlt);
      return;
    }

    const animatedSrc = this.getAttribute('data-animated-logo');
    const animatedAlt = this.getAttribute('data-animated-alt') || this.img.alt;

    if (
      window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
      !staticSrc
    ) {
      this.setLogoImage(staticSrc, staticAlt);
    } else if (animatedSrc) {
      this.setLogoImage(animatedSrc, animatedAlt);

      this.timeoutId = setTimeout(() => {
        if (this.img && this.img.parentElement && this.img.getAttribute('data-ada-switched') !== 'true') {
          this.img.setAttribute('data-ada-switched', 'true');
          this.setLogoImage(staticSrc, staticAlt);
        }
      }, 4500);
    }
  }
}

if (!customElements.get('animated-logo')) {
  customElements.define('animated-logo', AnimatedLogo);
}
